import { Component, inject, OnInit } from '@angular/core';
import { FADEIN_OUT_ANIMATION } from '../../../shared/constants/animations';
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, Meta, SafeHtml, Title } from "@angular/platform-browser";
import { environment } from '../../../../environments/environment';

@Component({
  // animations: FADEIN_OUT_ANIMATION,
  selector: 'app-prospective-members',
  imports: [NgbAccordionModule],
  templateUrl: './prospective-members.component.html',
  styleUrl: './prospective-members.component.scss'
})
export class ProspectiveMembersComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);
  faq = [
    {
      count: 1,
      question: 'How do I know if I’m in the PFW delivery zone?',
      answer: 'We deliver to within a 30 mile radius of Philadelphia. During the summer we also deliver to the Jersey Shore. To see a full map of our delivery area, <a href="https://www.google.com/maps/d/u/0/viewer?mid=1BEjE30doE8rTuzSafIUjhlYjXoP4wsY&ll=39.621826902908076%2C-75.03865350000001&z=9" target="_blank"> click here</a>.'
    },
    {
      count: 2,
      question: 'How do you pack/delivery my order?',
      answer: '<p>Your order is packed with returnable and recyclable materials. Returnable materials include the box, insulated cold sleeve, ice pack, and plastic clamshells. 99% of the remaining packaging is recyclable. With over 10 years of experience in packing produce and local food, we take great care to minimize product damage and ensure the safety of your items during transit.</p>' +
        '<p>We handle all deliveries with our branded refrigerated vans, keeping you informed on the delivery day so you know when to expect your order. You can choose convenient delivery times, and you\'ll see a familiar face each week as our drivers are Philly Foodworks employees. We take pride in building strong relationships with our customers.</p>'
    },
    {
      count: 3,
      question: 'Do I have to have a share?',
      answer: 'Nope! You can add individual items to your order each week. Just ensure you meet the $28 minimum and place your order before the cut-off time. The market opens on Friday at 9 a.m. and closes at 7 a.m. the day before delivery.'
    },
    {
      count: 4,
      question: 'What are the benefits of a recurring share?',
      answer: '<h6>Recurring shares are great for two reasons:</h6>' +
        '<ol>' +
        '<li>Recurring shares offer convenience and variety. Simplify your grocery shopping with customizable shares for produce, cheese, and protein boxes, with contents rotated weekly.</li>' +
        '<li>Our rotating product boxes introduce you to new foods and regional producers, providing a healthy mix of familiar and adventurous items.</li>' +
        '</ol>' +
        '<p>Each week, we\'ll automatically add items to your cart based on your selected boxes. When you log in, you can choose what to keep or delete. You might even be inspired to try something new—like the underrated celeriac, which is delicious in chicken noodle soup!</p>'
    },
    {
      count: 5,
      question: 'So, how do market hours work? When do I place orders?',
      answer: '<p>Glad you asked! Our market opens on Fridays at 9:00 a.m. By then, our inventory is updated with deliveries from local farmers and food producers. If you have a recurring subscription, you can log in to see what will be delivered the following week.</p>' +
        '<p>To make changes to your basket or cancel your order, do so before the market shopping window closes:</p>' +
        '<ul>' +
        '<li>Tuesday delivery — finalize by 7 a.m. Monday</li>' +
        '<li>Wednesday delivery — finalize by 7 a.m. Tuesday</li>' +
        '<li>Thursday delivery — finalize by 7 a.m. Wednesday\n</li>' +
        '</ul>'
    },
    {
      count: 6,
      question: 'Are there any membership fees, order minimums, or other small print?',
      answer: '<p>Creating a Philly Foodworks membership is free.</p>' +
        '<p>We charge an $8 delivery fee with no additional processing fees.</p>' +
        '<p>There is a $28 order minimum. Orders below the minimum by the shopping cut-off time will not be processed.</p>'
    },
    {
      count: 7,
      question: 'How does delivery work?',
      answer: '<p>We deliver on Tuesday, Wednesday, and Thursday between 10 a.m. and 8 p.m. Delivery days vary by region, with more options closer to Philadelphia. Many customers can choose from multiple delivery days and specific time windows, but options decrease the farther you are from the city.</p>' +
        '<p>You\'ll receive text updates when your order is out for delivery, nearing your home, and once it has been delivered. For specific delivery time inquiries, email us for an updated timeframe</p>'
    },
    {
      count: 8,
      question: 'Do you have any type of frequent shopper rewards program or memberships?',
      answer: '<p>Yes! Our Roots Rewards membership costs $15 dollars per month and gives you:</p>' +
        '<ul>' +
        '<li>Free home delivery</li>' +
        '<li>20% off every 10 orders</li>' +
        '<li>Lower order minimum of $20 </li>' +
        '</ul>' +
        '<p>For more information <a href="https://ecommerce-pfw.navego.tech/pages/how-it-works/rewards-program">click here</a>. You can sign up for Roots Rewards directly in your Philly Foodworks account.</p>'
    },
    {
      count: 9,
      question: 'Is your food organic?',
      answer: '<p>We prioritize organic or chemical-free produce as much as possible. Some of our producers are certified organic, some hold certifications such as Pest Management practices, and others use conventional methods. We note growing practices with icons on each product card so you know what you\'re buying.</p>' +
        '<p>We’ve made a commitment to local producers within 150 miles of Philadelphia. We talk with each producer to better understand how they treat their land and animals and what kind of ingredients they use. We recognize that official organic certification can be too costly for many small farmers, even though they abide by organic practices. We consider what kinds of regenerative agriculture practices, pasture-raised animals, and chemicals are in use.</p>' +
        '<p>For non-local procurement, we source staple produce items from a local, family-owned distributor known for treating its employees well.  This distributor has some difficulty sourcing fair trade or organic produce. We tried to work with a distributor that focused on organic however since the bast majority of what we buy is direct from farms (92%) we could not meet their ordering minimums year round. Additionally, we work with Miami Fruit, a group collaborating with small farms in Miami that use regenerative farming practices.</p>'
    },
    {
      count: 10,
      question: 'How can I further support our farmers?',
      answer: '<p>Customers can buy "CSA shares" before the season starts, providing farmers with crucial early-season income during a time of limited cash flow. This advance payment allows farmers to purchase materials in bulk and invest in equipment to boost yields and efficiency for the upcoming growing season.</p>' +
        '<p>When you set up a new Philly Foodworks account, you can register for the prepayment program. If you already have an account, email <a href="mailto:info@phillyfoodworks.com">info@phillyfoodworks.com</a> to join the program.</p>'
    },
  ];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/faq/prospective-members'
    const component = 'Prospective Members'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
